import React from 'react';
import { Link } from 'react-router-dom';

// Single source of truth for the official ProofNation logo asset.
// Transparent-background PNGs (no white box). 'onDark' swaps the navy "Proof"
// wordmark for a white one so it stays legible on dark surfaces.
const LOGO_SRC = '/proofnation-logo.png';
const LOGO_SRC_DARK = '/proofnation-logo-light.png';

const Logo = ({ variant = 'default', className = '', imgClassName = '', to = '/', withTagline = false, testId = 'brand-logo' }) => {
  const img = (
    <img
      src={variant === 'onDark' ? LOGO_SRC_DARK : LOGO_SRC}
      alt="ProofNation"
      data-testid={testId}
      className={`object-contain ${imgClassName || 'h-9'}`}
    />
  );

  const content = img;

  const inner = (
    <span className="inline-flex flex-col leading-none">
      {content}
      {withTagline && (
        <span className="mt-1 text-[10px] tracking-widest uppercase text-slate-500">Printing Solutions · Expert Support</span>
      )}
    </span>
  );

  if (to) {
    return (
      <Link to={to} className={`inline-flex items-center ${className}`} aria-label="ProofNation home">
        {inner}
      </Link>
    );
  }
  return <span className={`inline-flex items-center ${className}`}>{inner}</span>;
};

export default Logo;
